<template>
  <div class="row mt-2 p-3" v-if="material?.requiresSerialNumbers">
    <table class="table table-sm">
      <thead>
        <tr>
          <th style="width: 60%">Serijska</th>
          <th v-if="material.isBatchSerial">Količina po embalaži</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in batchSerialNumbers" :key="index">
          <td>
            <input class="form-control" type="text" v-model="item.serial" :disabled="disabled" />
          </td>
          <td v-if="material.isBatchSerial">
            <div class="input-group">
              <input class="form-control" type="number" v-model="item.quantity" step=".1" :disabled="disabled" />
              <span class="input-group-text" v-show="material.isBatchSerial">{{ material.measurementUnit }}</span>
            </div>
          </td>
        </tr>
        <tr v-if="isBatchSerial.isBatchSerial">
          <td>Skupaj:</td>
          <td class="fw-bold">
            {{ batchSerialNumbers.reduce((acc, curr) => acc + curr.quantity, 0) }} {{ material.measurementUnit }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import { ref, toRef, toRefs, computed, defineComponent, watch, reactive, onMounted, inject } from "vue"

defineOptions({ name: "MaterialBatchList" })

const props = defineProps({
  modelValue: Array, // batchSerialNumbers
  modelModifiers: { default: () => ({}) },
  material: { type: Object, required: true },
  isBatchSerial: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
})

const emit = defineEmits(["update:modelValue"])

const batchSerialNumbers = ref(props.modelValue || [])

watch(
  () => props.modelValue,
  (newVal) => {
    if (newVal) {
      batchSerialNumbers.value = newVal
    }
  },
)

watch(
  batchSerialNumbers,
  (newVal) => {
    emit("update:modelValue", newVal)
  },
  { deep: true, immediate: true },
)
</script>
